<script>
  import { format } from 'svelte-i18n';

  /**
   * Translation key for the message text.
   * @type {string}
   */
  export let message = '';
</script>

<div class="no-matches">
  <div>
    {message}
  </div>
</div>

<style lang="scss" src="./no-matches.scss"></style>
